import { openFlash } from './global';

export const forbiddenAction = () => openFlash('You are not allowed to do this action.', 'error');
